import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Storefront",
  "use": "Storefront-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"Storefront\"><path d=\"M28.4 3.6H3.6v3.1h24.9V3.6zM30 19.1V16l-1.6-7.8H3.6L2 16v3.1h1.6v9.3h15.6v-9.3h6.2v9.3h3.1v-9.3H30zm-14 6.2H6.7v-6.2H16v6.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol